export default {
  actionLoading: (state) => state.actionLoading,
  loading: (state) => state.loading,
  items: (state) => state.items,
  search: (state) => state.search,
  sort: (state) => state.sort,
  termsAccepted: (state) => state.terms_accepted,
}
